/**
 * Dedicated helper for resetting ad library ad elements for safe assignment.
 */
const resetAdElements = () => {
  if (window.__AdLib && window.__AdLib.elementManager) {
    window.__AdLib.elementManager.adElements = {};
  }
};

/**
 * Removes all previous ad slots from the web-ad-lib SlotManager instance.
 */
const removeAdSlots = () => {
  if (window.__AdLib) {
    window.__AdLib.slotManager?.destroyAdSlots();
    resetAdElements();
  }
};

/**
 * Registers all ad elements on the DOM into the web-ad-lib workflow.
 */
export const loadAdSlots = () => {
  window.__AdLib?.elementManager?.registerSlots();
};

/**
 * Refresh single ad slot given element #id
 */
export const refreshAdSlot = (divId) => {
  return window.__AdLib?.slotManager?.refreshAdSlots(divId);
};

/**
 * Handles behavior for ad reinitialization on page transitions.
 * Required for VICEMedia/web-ad-lib SPA support.
 */
export const initAdSlots = () => {
  removeAdSlots();
  loadAdSlots();
};

/**
 * If ad_sponsorship is not null is checked, run this script to disable OpenWeb ads
 */
export const disableOpenWebAds = () => {
  if (window.__AdLib) {
    window.__SPOTIM_ADS_DISABLED__ = true;
    window.__SPOTIM_DISABLE_ADS__ && window.__SPOTIM_DISABLE_ADS__();
  }
};
